{
  "en": {
    "pupilFeedback": {
      "deprecationAlert": {
        "title": "This tool is hidden by default",
        "description": "It can be enabled at school level if required.",
        "learnMoreLink": "Learn more"
      },
      "unlockedAlert": {
        "title": "This tool is unlocked for your school",
        "description": "It will not be further developed, but remains usable for your school.",
        "learnMoreLink": "Learn more"
      },
      "alerts": {
        "example": "What can that look like?",
        "exampleButton": "Insert example for task and criteria",
        "noFeedbackYet": "No feedback could be generated. Please check your inputs and try again.",
        "pupilFeedback": "<strong>Note:</strong> The feedback is automatically generated by an AI based on the specified criteria and may contain errors. If you have any questions or uncertainties, please contact a teacher.",
        "pupilFeedbackStudent": "<strong>Note:</strong> The feedback is AI-generated and is based on the tasks, materials, and criteria set by your teacher. If you have any questions or uncertainties, please reach out to your teacher.",
        "submitting": "Your feedback is being generated.",
        "submittingDescription": "Please wait a moment."
      },
      "example": {
        "criteriaAttributes": {
          "0": "The story has a clear beginning, middle, and end, and it has a title. The events happen in order and lead to a short ending. The title matches what the story is about.",
          "1": "The story uses exciting words to make it interesting. You use words like 'scary', 'spooky', and 'dark', and you describe what the characters see, hear, and feel.",
          "2": "The story has correct grammar and spelling. You make sure the sentences are written correctly, use the right verb tenses, and spell words properly so it's easy to read.",
          "3": "The story starts sentences in different ways to keep it interesting."
        },
        "description": "Read the newspaper article ‘Night on the moor’. Write a spooky story based on the events. Pay attention to the design criteria to make your story as exciting as possible.",
        "material": "1) Newspaper article <br> BOSTON A father and his children had to endure a scary night in a moor near Boston. After his bike broke down, Mr T. tried to walk home with Maria (12) and Tom (10). In the frost and fog, however, they got lost in the moor. A large-scale police search operation launched by the worried mother was only successful in the morning: police sniffer dogs found the three of them completely frozen.",
        "name": "Spooky story"
      },
      "flash": {
        "textExtractionSuccess": "Text extraction successful"
      },
      "headings": {
        "criteria": "Criterion",
        "form": "Define task and criteria"
      },
      "hints": {
        "experimental": "The feedback tool for students provides <strong>AI-generated feedback</strong> for student work based on assignments, materials, and criteria provided by educators. Understanding the <strong>recommended guidelines and limitations of AI</strong> is crucial for the responsible use and interpretation of this feedback. <a href='https://app.fobizz.com/en/help/articles/256-ai-guidelines' target='_blank'>Learn more</a>",
        "noSubmission": "No submission yet",
        "submitSuccessful": "Thank you! You have successfully submitted your assignment.",
        "submitSuccessfulShort": "Assignment submitted successfully"
      },
      "infoMessages": {
        "criteria": "Define clear criteria for the AI to generate feedback. The more detailed you formulate the criteria, the more precise the feedback will be.",
        "criterion": "At least one criterion necessary"
      },
      "labels": {
        "allResponses": "All answers",
        "answer": "Answer",
        "assignment": "Assignment",
        "assignmentTitle": "Assignment Title",
        "averageScore": "Average score:",
        "criteria": "Feedback Criteria",
        "criteriaVisibleForPupils": "Visible for students",
        "difference": "Differences to the 1st version",
        "draftsAndSubmissions": "Drafts and Submissions",
        "editFeedback": "Revise my response",
        "emptySubmission": {
          "description": "Share the task with your students and as soon as you get feedback on their first version, you will see the progress here.",
          "title": "There are no drafts or submissions for this task yet."
        },
        "feedback": "Feedback",
        "finalSubmission": "Submission | Submissions",
        "finalSubmit": "Final submission",
        "firstSubmission": "1. version | 1. versions",
        "material": "Material",
        "materialVisibleForPupils": "Visible for students",
        "noScoreYet": "No score yet",
        "of": "of {count}",
        "score": "Score",
        "submit": "Give me feedback"
      },
      "links": {
        "imageRecognition": "Upload text from image",
        "textExtraction": "Upload text from PDF",
        "toggleFeedbackDetails": "Show feedback"
      },
      "modals": {
        "confirm": {
          "helpLink": "https://app.fobizz.com/en/help/articles/256-ai-guidelines",
          "text": "The AI for feedback tool, specifically designed for students, provides <strong>AI-generated feedback</strong> for student work based on assignments, materials, and criteria provided by educators. It is essential to understand the <strong>recommended guidelines and limitations of AI</strong> to ensure the responsible use and accurate interpretation of this feedback.",
          "title": "Notes on using the AI Feedback tool"
        }
      },
      "placeholders": {
        "answer": "Enter your answer here...",
        "assignment": "Describe the task",
        "assignmentTitle": "Enter title...",
        "criterion": "Enter criterion...",
        "language": "Language for the AI feedback",
        "material": "Include additional resources or supporting material for working on the assignment here."
      },
      "responseItem": {
        "confirmDelete": {
          "confirm": "Delete",
          "text": "This action cannot be undone. The response will be permanently deleted.",
          "title": "Delete response?"
        },
        "delete": "Delete answer",
        "firstFeedback": "1. version",
        "share": "Copy student link",
        "submission": "Submission"
      },
      "simpleLanguage": {
        "loading": "Loading...",
        "translate": "Show feedback in simple language"
      }
    },
    "pupil_feedback": {
      "anonymous": "Anonymous"
    }
  }
}
